import * as actionTypes from '../constants/actionTypes'
import createReducer from '../utils/createReducer'

export const defaultState = {
  open: false,
  typeSnackbar: 'success',
  message: 'Успешно!',
  autoHideDuration: 2000
}

const snackbarReducer = () => {
  return createReducer(defaultState, {
    [`${actionTypes.SNACKBAR_OPEN}`] (state, { payload }) {
      return {
        ...state,
        ...payload,
        open: true
      }
    },

    [`${actionTypes.SNACKBAR_CLOSE}`] (state) {
      return {
        ...state,
        open: false
      }
    }
  })
}

export default snackbarReducer
